// extracted by mini-css-extract-plugin
export var aggregationCell = "_2g-k";
export var aggregationRow = "_2g-j";
export var borderlessSpinnerContainer = "_2g-3";
export var closeIcon = "_2g-c";
export var columnHeaderSurface = "_2g-8";
export var columnHeaderSurfaceDragOverlay = "_2g-s";
export var columnHeaderSurfaceResizing = "_2g-p";
export var contextMenuAnchor = "_2g-1";
export var draggableColumnHeader = "_2g-q";
export var draggableColumnHeaderOverlay = "_2g-r";
export var expandIcon = "_2g-d";
export var expanded = "_2g-e";
export var filterDropdown = "_2g-f";
export var filterDropdownDivider = "_2g-a";
export var filterDropdownHeader = "_2g-i";
export var filterDropdownItem = "_2g-h";
export var filterDropdownModal = "_2g-g _2g-f";
export var filterItem = "_2g-9";
export var normalCellWithAdjustableBorder = "_2g-b";
export var pinButtonContainer = "_2g-l";
export var pinIcon = "_2g-m";
export var pinIconActive = "_2g-n";
export var spinner = "_2g-0";
export var spinnerContainer = "_2g-2";
export var tableContainer = "_2g-4";
export var tableContentDraggingColumns = "_2g-7";
export var tableContentInner = "_2g-6";
export var tableContentWrapper = "_2g-5";
export var viewButtonContainer = "_2g-o";